var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('a',{attrs:{"target":"_blank","href":_vm.url}},[_c('canvas',{ref:"myCanvas",attrs:{"id":_vm.id}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }